// removed by extract-text-webpack-plugin
module.exports = {"event-share-container":"event-share-modal__event-share-container__16Hx4","title":"event-share-modal__title__3L99L","description":"event-share-modal__description__3rHj6","subtitle":"event-share-modal__subtitle__3D4P5","input-wrapper":"event-share-modal__input-wrapper__1i5m2","icon":"event-share-modal__icon__94Sdf","or-text":"event-share-modal__or-text__1We7T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/EventShareModal/event-share-modal.scss
// module id = 1378
// module chunks = 1